/**
 * @file
 * Attaches the behaviors for WBD Hero component.
 */

(($, Drupal, Sortable) => {
  const { ajax, behaviors, debounce, announce, formatPlural } = Drupal;

  Drupal.heroComponent = Drupal.heroComponent || {};
  Drupal.heroComponent.closePopup = function (event) {
    const $popup = $(event.target).closest('.wbd-cmp--popup');
    const $heroVideo = $popup.data('heroVideo');

    $popup.remove();

    if ($heroVideo?.length) {
      $heroVideo[0].play();
    }
  }

  Drupal.behaviors.wbdComponentHero = {
    attach(context) {
      $(".wbd-component__hero--trigger-sizzle-reel-popup", context).click(function(e){
        e.preventDefault();
        const this_video_url = $(this).attr("data-sizzle-url");
        const this_video_poster = $(this).attr("data-sizzle-poster");

        const $heroVideo = $(this)
          .closest('.wbd-component__hero-video__wrapper')
          .find('.wbd-component__hero-video--container video');

        if ($heroVideo.length) {
          $heroVideo[0].pause();
        }

        $heroVideo[0]?.pause();

        if (!$('body').find('.popup').length) {
          const $popupHtml = `<div class="wbd-cmp--popup" id="wbd-cmp--popup">
          <button class="wbd-cmp--popup-close" onclick="Drupal.heroComponent.closePopup(event)">${Drupal.t('Close')}</button>
          <div class="wbd-cmp--popup-content"></div>
        </div>`;

          $("body").append($popupHtml);
          $(".wbd-cmp--popup").data('heroVideo', $heroVideo);

          $(".wbd-cmp--popup").addClass("is-sizzle-video");
          $(".wbd-cmp--popup .wbd-cmp--popup-content").html('<video src="' + this_video_url + '" poster="' + this_video_poster + '" aria-labelledby="hero-video-label" controls >');
        }
      });
    }
  }
})(jQuery, Drupal);
